<script lang="ts">

import { Component, mixins, Prop } from "vue-facing-decorator";
import ResultsComponent from "@/components/search/Results.vue";
import SearchComponent from "@/components/search/Search.vue";
import { BreakpointHandler } from "@/mixins/BreakpointHandler.mixin";
import { SearchRequest } from "@/domain/search/entitites/SearchRequest.interface";
import { useSearchResultsStore } from "@/domain/search/application/SearchResults.store";
import { LanguageCode, TranslationService, Url } from "webshop-modules";
import { useAppliedFiltersStore } from "@/domain/search/application/AppliedFilters.store";
import { SearchAppData } from "@/domain/search/entitites/TranslationsData.interface";
import SpinnerComponent from "@/components/atoms/Spinner.vue";

@Component({
    components: {
        SpinnerComponent,
        ResultsComponent,
        SearchComponent,
    },
})
export default class Search extends mixins(BreakpointHandler) {

    @Prop()
    public data!: SearchAppData;

    public readonly searchResultStore = useSearchResultsStore();
    public readonly appliedFiltersStore = useAppliedFiltersStore();

    public get filterList(): SearchRequest {
        return this.searchResultStore.filterList as SearchRequest;
    }

    public headerKey = 0;

    public url: Url = new Url(window.location.href);

    public lang: string = TranslationService.getLanguageCode() !== LanguageCode.Slovenian
        ? TranslationService.getLanguageCode()
        : 'si';

    private rerenderOnBreakpointChange() {
        this.headerKey += 1;
    }

    /** Breakpoint change handler method */
    protected handleBreakpointChange(): void {
        this.rerenderOnBreakpointChange();
    }

    /**
     * Created lifecycle hook
     */
    private async created() {
        if (this.url.getSearchParam('searchText') !== undefined) {
            this.filterList.searchText = decodeURIComponent(this.url.getSearchParam('searchText')!.replace(/\+/g, ' '));
        }

        if (this.url.getSearchParam('category') !== undefined) {
            this.filterList.category = this.url.getSearchParam('category')!.split(',').map(Number);
        }

        if (this.url.getSearchParam('mainCategory') !== undefined) {
            this.filterList.mainCategory = this.url.getSearchParam('mainCategory')!.split(',').map(Number);
        }

        if (this.url.getSearchParam('city') !== undefined) {
            this.filterList.city = decodeURIComponent(this.url.getSearchParam('city')!).split(',');
        }

        if (this.url.getSearchParam('country') !== undefined) {
            this.filterList.country = this.url.getSearchParam('country')!.split(',');
        }

        if (this.url.getSearchParam('dateStart') !== undefined) {
            this.filterList.dateStart = new Date(decodeURIComponent(this.url.getSearchParam('dateStart') as string));
        }

        if (this.url.getSearchParam('dateEnd') !== undefined) {
            this.filterList.dateEnd = new Date(decodeURIComponent(this.url.getSearchParam('dateEnd') as string));
        }

        const params = Object.entries(this.filterList).reduce(function (res: any, item) {
            if (item[1].length > 0) {
                res[item[0]] = item[1].toString();
            } else if (item[0] === 'searchText') {
                res[item[0]] = item[1];
            } else {
                const date = new Date(item[1]);
                res[item[0]] = new Date(date.getTime() + (date.getTimezoneOffset() * 60000));
            }
            return res;
        }, {});

        params.lang = this.lang;

        await this.appliedFiltersStore.updateAppliedFilters(params);
        await this.searchResultStore.getData(false, this.$apiService);
    }
}
</script>

<template>
    <SearchComponent :data="data" :key="headerKey"/>
    <ResultsComponent :data="data"/>
</template>
